<template>
  <div class="vx-col w-full md:w-1/2 lg:w-1/3 mb-base" v-show="isAllowed">    
    <vx-card slot="no-body" class="text-center greet-user">
        <router-link :to="link" v-b-tooltip.hover :title="title">
          <feather-icon 
            :icon="icon"
            class="p-6 mb-8 bg-secondary inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8" >
          </feather-icon>
          <h1 class="mb-6 text-primary" >
            {{ title }}
          </h1>
      </router-link>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: 'home-menu-item',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String
    },
    link: {
      type: String,
      required: true
    },
    roles: {
      type: Array,
      required: true
    }    
  },
  computed: {
    isAllowed () {
      return this.$auth.checkRoles(this.$props.roles);
    }
  }
}
</script>